import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funktionsbereiche-pruefplaene-controlling';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksFunktionsbereichePruefplaeneControllingEffects {

    FunktionsbereichePruefplaeneControlling$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKTIONSBEREICHE_PRUEFPLAENE_CONTROLLING),
        mergeMap((x: ac.GetFunktionsbereichePruefplaeneControllingAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunktionsbereichePruefplaeneControlling().pipe(
                map((result: any) => {
                    return new ac.GetFunktionsbereichePruefplaeneControllingErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunktionsbereichePruefplaeneControllingFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ControllingQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ControllingQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ControllingQueryService);
        }
        return this.service;
    }
}
